import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import TelegramLanding from './components/pages/TelegramLanding'
import BlogListPage from './components/pages/BlogListPage'
import BlogArticlePage from './components/pages/BlogArticlePage'
import NotFoundPage from './components/pages/NotFoundPage'
import CookieConsent from './components/layout/CookieConsent'
import {parseRoute} from './utils/routeParser'
import {getBlogArticleBySlug} from './config/blogArticles'
import {initConsentedAnalytics} from './utils/consent'
import './fonts.css'
import './index.css'

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
}

// Analytics/monitoring (Yandex.Metrika, Sentry) run only after the visitor has
// accepted cookies (152-ФЗ). This re-enables them for returning visitors who
// already consented; first-time visitors enable them via the consent banner.
initConsentedAnalytics();

// Path-based routing
function Router() {
    const path = window.location.pathname;
    const route = parseRoute(path);

    // Telegram landing
    if (route.type === 'telegram') {
        return <TelegramLanding/>;
    }

    // Blog
    if (route.type === 'blog') {
        return <BlogListPage/>;
    }
    if (route.type === 'blogArticle') {
        if (!getBlogArticleBySlug(route.slug)) {
            return <NotFoundPage/>;
        }
        return <BlogArticlePage slug={route.slug}/>;
    }

    // Orders page
    if (route.type === 'orders') {
        return <App view="orders"/>;
    }

    // Home or HR pages
    if (route.type === 'home' || route.type === 'hr') {
        return <App view="home"/>;
    }

    // 404 page
    return <NotFoundPage/>;
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={
            <div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', padding: '20px', textAlign: 'center'}}>
                <div>
                    <p style={{fontSize: '18px', color: '#333', marginBottom: '16px'}}>Что-то пошло не так. Попробуйте обновить страницу.</p>
                    <button onClick={() => window.location.reload()} style={{padding: '12px 24px', background: 'linear-gradient(to right, #e53e3e, #ed64a6, #ed8936)', color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', cursor: 'pointer'}}>
                        Обновить
                    </button>
                </div>
            </div>
        }>
            <Router/>
            <CookieConsent/>
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
)
